import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { useGet, usePost } from 'components';
import { ErrorPopup } from 'components';
import { getProductEditModel } from './productEditFormModel';
import { Redirect, Link } from "react-router-dom";
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';

import { ImageSelector } from './imageSelector';
//import { MediaSelector } from './mediaSelector';
import { VariantAttributes } from './variantAttribute/variantAttributeList';
import { Variants } from './variantList/variantList';
import { getVariants } from './variantList/variantModel';

import utils from 'utils';

export function ProductEdit(props) {
  const { query } = useRouter();
  const get = useGet();

  const productCode = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + `/api/productAdmin/getProduct/${productCode}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  const model = getProductEditModel(data);
  console.log(model)

  return <ProductEditForm model={model} data={data} productCode={productCode} />
}


export function ProductEditForm({ model, data, productCode }) {
  const form = useForm(model, {});
  const post = usePost();

  const [variantAttrs, setVariantAttrs] = React.useState(data.variantAttributes || []);
  const [variants, setVariants] = React.useState(data.variants || []);

  React.useEffect(() => {
    setVariants([...getVariants(variantAttrs, variants)])
    // eslint-disable-next-line
  }, [variantAttrs]);

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue(), orgProductCode: productCode, variantAttributes: variantAttrs, variants: variants };

      console.log(value)
      //return;
      post.send(env.apiBase + "/api/productAdmin/saveProduct", value);
    })
  }

  function remove(e) {
    if (!window.confirm('Delete this??')) return;
    post.send(env.apiBase + "/api/productAdmin/removeProduct", { productId: productCode });
  }

  function suggestUrl() {
    const value = form.getValue();
    const productUrl = form.findControl('productSlug');
    productUrl.value = utils.url.getSlug(value.productName);
    form.reset()
  }

  if (post.status === 'done') {
    return <Redirect to="/admin/products" />
  }

  const productUrlAU = data.productUrl ? env.baseUrl + data.productUrl : `${env.baseUrl}/product/${data.productCode}`;

  const formVal = form.getValue();

  return (
    <div className="editor productEditor">
      <div className="productEditor__links">
        {formVal.productStatusAU !== 99 && <a href={productUrlAU} rel="noopener noreferrer" target="_blank">Product Page</a>}
      </div>
      <h1>Product Edit</h1>

      <section>
        <div className="row">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12">{render('productName')}</div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('productSlug')}
                <div style={{ textAlign: 'right' }}>
                  <button type="button" className="btn btn-outline-info btn-sm" onClick={suggestUrl}>Suggest URL from product name</button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('productStatus')}</div>
              <div className="col-md-6">{render('productCode')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('productType')}</div>
              <div className="col-md-6">{render('taxCode')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('price')}</div>
              {/* <div className="col-md-6">{render('retailPrice')}</div> */}
            </div>
            <div className="row">
              <div className="col-md-6">{render('shippingFeeType')}</div>
              <div className="col-md-6">{render('shippingFee')}</div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('categoryIds')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('shortDesc')}<WordCounter form={form} field="intro" forMeta={false} /></div>
              <div className="col-md-6">{render('metaDesc')}<WordCounter form={form} field="metaDesc" forMeta={true} /></div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('description')}</div>
            </div>
          </div>
          <div className="col-md-6">
            <label className="label">Product Images</label>
            <ImageSelector form={form} data={data} fieldName="productImages" />

            <hr />
            <h3>Variant Attributes</h3>
            <VariantAttributes form={form} data={data} variantAttrs={variantAttrs} setVariantAttrs={setVariantAttrs} />
            <hr />
            <h3 style={{ marginTop: '1rem' }}>Variants</h3>
            <Variants form={form} data={data} variants={variants} setVariants={setVariants} variantAttrs={variantAttrs} />
          </div>
        </div>

        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Save</Button>
            {productCode &&
              <Button onClick={remove} status={form.status} btnStyle="outline-primary">Delete</Button>}
            <Link className="btn btn-outline-dark" to="/admin/products">Cancel</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function WordCounter({ form, field, forMeta }) {
  const val = form.getValue()[field];
  const length = (val || '').length;
  const style = { color: forMeta ? (length < 50 || length > 160 ? 'red' : 'limegreen') : '#666', fontSize: '0.8rem' }
  return <div style={style}>{length} {length === 1 ? 'character' : 'characters'}
    {forMeta && <span style={{ color: '#666', marginLeft: '1rem' }}>(50-160 characters recommended)</span>}
  </div>
}
